export default "__VITE_ASSET__sBHHMf51__"